import React from "react";
import "./Footer.css";
import { FaFacebookF, FaXTwitter, FaLinkedinIn, FaYoutube, FaInstagram, FaTiktok } from "react-icons/fa6";
import logoimg from "../assets/Footer-logo.png";

export default function Footer() {
  return (
    <footer className="cm-footer">
      <div className="cm-footer-container">

        {/* Left Side */}
        <div className="cm-footer-left">
          <img
            src={logoimg}
            alt="CM Group of Companies"
            className="cm-footer-logo"
          />
          <h2 className="cm-footer-heading">
            Leading the <span>Transformation</span> to a Clean Energy Economy
          </h2>
        </div>

        {/* Right Side */}
        <div className="cm-footer-right">
          
          <div className="cm-footer-social">
            <FaFacebookF />
            <FaXTwitter />
            <a
  href="https://www.linkedin.com/in/cm-group-of-companies-644059416/"
  target="_blank"
  rel="noopener noreferrer"
  aria-label="LinkedIn"
>
  <FaLinkedinIn style={{ color: "#fff" }} />
</a>
            <FaYoutube />
            <FaInstagram />
            <FaTiktok />
          </div>

          <div className="cm-footer-info">
            <div className="cm-footer-section">
              <h4>ADDRESS</h4>
              <p>Cm group of companies, <br />No:1 Aiswarya nagar,<br />Udumalpet-642126.</p>
            </div>

                        <div className="cm-footer-section">
  <h4>CONTACT</h4>
  <p>
    Phone:{" "}
    <a href="tel:+919944662747" className="cm-footer-link">
      +91 99446 62747
    </a>
    <br />
    Email:{" "}
    <a
      href="mailto:cmpranesh@cmgroupofcompanies.com"
      className="cm-footer-link"
    >
      cmpranesh@cmgroupofcompanies.com
    </a>
  </p>
</div>
          </div>
        </div>
      </div>

      <div className="cm-footer-bottom">
       <p>
  © 2026 CM Group of Companies. All Rights Reserved. Designed & Developed by
  <a href="https://srirambranding.com" target="_blank"
  rel="noopener noreferrer"
  className="no-underline">
    <strong>  Sriram Branding</strong>
  </a>.
</p>

        <div className="cm-footer-links">
          <a href="/terms">Terms of Service</a>
          <span>|</span>
          <a href="/policy">Privacy Policy</a>
        </div>
      </div>
    </footer>
  );
}
